/**
 * Setup webpack public path
 * to enable lazy-including of
 * js chunks
 *
 */
/* global urls:true */
import * as bootstrap from 'bootstrap';
import $ from 'jquery';

import "./scripts/forms";
import "./scripts/rpm-chart";

window.jQuery = $;
window.$ = $;


document.addEventListener('DOMContentLoaded', () => {

});

$(window).resize(() => {

});

